// Frontend-helpers voor opportunity-stage beschrijvingen (tooltips). Spiegelt
// backend/src/utils/oppStage.js: varianten met een "(…)"-suffix (bv. "Acq. (cu.)")
// delen dezelfde beschrijving → we sleutelen op de genormaliseerde basis-stage.
// Streepjes (en-/em-streepje uit Odoo) worden een gewoon koppelteken, zodat
// "Risk Review – Pending Guarantee" dezelfde sleutel geeft als de getypte tekst.

import { createContext, useContext } from 'react';

export function normalizeStage(value) {
  return String(value || '').replace(/\s*\([^)]*\)\s*$/, '').trim().toLowerCase()
    .replace(/[‐-―−]/g, '-').replace(/\s+/g, ' ');
}

// Map { stage_key: { label, description } }, geleverd door /api/opportunity-stages.
export const StageDescContext = createContext({});

// Lookup-hook: geeft een functie (stageValue) => beschrijving (of '').
export function useStageDesc() {
  const map = useContext(StageDescContext);
  return (value) => {
    if (!value) return '';
    const entry = map[normalizeStage(value)];
    return (entry && entry.description) || '';
  };
}
